import React, {useEffect, useState, useLayoutEffect} from "react";
import { Redirect, Route } from "react-router-dom";

import Api from "../../helpers/apiHelpers";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import WebFont from "webfontloader";
import {useLocation} from "react-router";
import {useBranding} from "../../hooks/useBranding";
import {useSnackbar} from "notistack";
import {getBranding} from "../../redux/branding/branding.actions";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
const PrivateRoute = ({children, ...rest}) => {
    const query = useQuery();
    const path = useLocation().pathname;
    const branding = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const partnerId = query.get("partnerId");
    const dispatch = useAppDispatch();
    const [brandingLoad, setBrandingLoad] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    useBranding();
    useLayoutEffect(() => {
        (async () => {
            if (branding) {
                const link = document.querySelector("link[rel='icon']");
                // @ts-ignore
                link.href = link.getAttribute("data-ico-label");
            }
            if (partnerId) {
                const link = document.querySelector("link[rel='icon']");
                // @ts-ignore
                link.href = link.getAttribute("data-ico-label");
                await dispatch(getBranding(partnerId)).then((res) => {
                    WebFont.load({
                        google: {
                            families: [res.font?.header, res.font?.text]
                        }
                    });
                    setBrandingLoad(true);
                }
                )
                    .catch(err => {
                        enqueueSnackbar("Can not find partner by given id", {
                            variant: "error",
                            autoHideDuration: 3000
                        });
                        setBrandingLoad(true);
                    }
                    );
            }
        })();
    }, []);
    //Add in logic for redirects of /gifts and /benefits
    return (
        Api.isLoggedIn?
            (
                ( !partnerId || brandingLoad ?
                    <Route {...rest}>
                        {children}
                    </Route>:<></>
                )
            )
            :
            (!partnerId || brandingLoad) && <Redirect to={{pathname: "/login", state: path === "/appointments" ? "" : path.substr(9)}}/>
    );
};

export default PrivateRoute;
